import { contactSchema } from "../contacts/types.js";
import { z } from "zod";
export const boaLocationSchema = z.object({
    addressCity: z.string().optional(),
    addressCountry: z.string().optional(),
    addressPostalCode: z.string().optional(),
    addressRegion: z.string().optional(),
    addressStreet: z.string().optional(),
    addressStreet2: z.string().optional(),
    businessStatus: z.enum(["OPERATIONAL", "CLOSED_PERMANENTLY", "CLOSED_TEMPORARILY", ""]).optional(),
    contacts: z.union([z.array(contactSchema), z.null()]).optional(),
    exempt: z.boolean().default(false),
    GSI1_PK: z.string().optional(),
    GSI1_SK: z.string().optional(),
    googlePlaceIds: z.union([z.array(z.string()), z.null()]).optional(),
    id: z.string(),
    locationUrl: z.string().optional(),
    name: z.string().optional(),
    phone: z.union([z.string(), z.null()]).optional(),
    PK: z.string().optional(),
    placeStatus: z.enum(["OK", "NOT_FOUND", ""]).optional(),
    region: z.union([z.string().optional(), z.null()]),
    SK: z.string().optional(),
    serviceArea: z.boolean().default(false),
    verifiedYears: z.array(z.number()).optional(),
    yelpUrl: z.string().optional(),
});
// export type BOALocation = {
//   addressCity: string;
//   addressCountry: string;
//   addressPostalCode: string;
//   addressRegion: string;
//   addressStreet: string;
//   addressStreet2?: string;
//   businessStatus: "OPERATIONAL" | "CLOSED_PERMANENTLY" | "CLOSED_TEMPORARILY";
//   candidateId: string;
//   contacts: Contact[];
//   exempt: boolean;
//   GSI1_PK: string;
//   GSI1_SK: string;
//   googlePlaceIds: string[];
//   id: string;
//   locationUrl: string;
//   name: string;
//   phone: string;
//   PK: string;
//   placeStatus?: "OK" | "NOT_FOUND" | "";
//   region?: string;
//   SK: string;
//   serviceArea: boolean;
//   verifiedYears: number[];
//   yelpUrl: string;
// };
//# sourceMappingURL=types.js.map